import React from "react";
import { Link, useParams } from "react-router-dom";
import NoAccess from "../NoAccess";
import { useUser } from "../../context/UserContext";
import { getRoleNames, hasAnyPermission } from "../../utils/tenantAdminAccess";
import { findModuleBySlug } from "./moduleCatalog";

function canAccessModuleDetail(module, user) {
  const roleNames = new Set(getRoleNames(user));
  if (roleNames.has("tenantadmin") || roleNames.has("platformadmin")) {
    return true;
  }

  if (!roleNames.has("projectleider")) {
    return false;
  }

  if (!Array.isArray(module?.permissionsAny) || module.permissionsAny.length === 0) {
    return true;
  }

  return hasAnyPermission(user, module.permissionsAny);
}

export default function TenantAdminModuleDetailPage() {
  const { moduleKey } = useParams();
  const { user } = useUser();
  const module = findModuleBySlug(moduleKey);

  if (!module) {
    return (
      <div className="min-h-screen bg-slate-50 p-4 md:p-6">
        <div className="mx-auto max-w-6xl rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <h1 className="text-2xl font-bold text-slate-900">Module niet gevonden</h1>
          <p className="mt-2 text-sm text-slate-600">
            De opgegeven module bestaat niet binnen dit tenantbeheer.
          </p>
          <Link to="/tenant-admin/modules" className="mt-4 inline-block text-sm text-slate-700 underline">
            Terug naar modules
          </Link>
        </div>
      </div>
    );
  }

  if (!canAccessModuleDetail(module, user)) {
    const roleNames = getRoleNames(user);
    const visibleRole = roleNames[0] || user?.rol || user?.role || "";
    return (
      <NoAccess
        allowedRoles={["TenantAdmin", "Projectleider (met module-rechten)"]}
        currentRole={visibleRole}
        requiredRoles={["TenantAdmin", "Projectleider (met module-rechten)"]}
        userRole={visibleRole}
      />
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-6">
      <div className="mx-auto max-w-6xl">
        <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
          <div>
            <h1 className="text-2xl font-bold text-slate-900">{module.title}</h1>
            <p className="text-sm text-slate-600">{module.description}</p>
          </div>
          <div className="flex flex-wrap gap-2">
            <Link
              to="/tenant-admin/modules"
              className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              Terug naar modules
            </Link>
            <Link
              to="/tenant-admin"
              className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
            >
              Terug naar hub
            </Link>
          </div>
        </div>

        <div className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
          <p className="text-sm text-slate-700">
            Dit is een placeholder-detailpagina. In de volgende iteratie koppelen we hier de concrete
            module-instellingen en mutatieformulieren.
          </p>
        </div>
      </div>
    </div>
  );
}
